import { useTranslation } from 'react-i18next';

import { DataPanel } from '@/ui';
import type { IncidentPsap } from '@/signalr';
import { DateTimeInfoPanel } from './DateTimeInfoPanel';
import { InvolvedPsapsPanel } from './InvolvedPsapsPanel';

export type IncidentBaseInfoPanelProps = {
  isCallFromMobileApp: boolean;
  appDisplayName: string;
  createdTimeUtc: string;
  closedTimeUtc: string | null;
  incidentIsReadOnly: boolean;
  incidentInvolvedPsapStates: readonly IncidentPsap[];
};

export function IncidentBaseInfoPanel({
  isCallFromMobileApp,
  appDisplayName,
  createdTimeUtc,
  closedTimeUtc,
  incidentIsReadOnly,
  incidentInvolvedPsapStates,
}: IncidentBaseInfoPanelProps) {
  const { t } = useTranslation();

  const panelHeader = isCallFromMobileApp
    ? t('Incident_InfoPanel_CallFromAppHeader')
    : `${t('Incident_InfoPanel_CallWithoutAppHeader')} ${appDisplayName}`;

  return (
    <DataPanel header={panelHeader}>
      <DateTimeInfoPanel
        createdTimeUtc={createdTimeUtc}
        closedTimeUtc={closedTimeUtc}
        incidentIsReadOnly={incidentIsReadOnly}
      />

      <InvolvedPsapsPanel
        createdTimeUtc={createdTimeUtc}
        closedTimeUtc={closedTimeUtc}
        incidentIsReadOnly={incidentIsReadOnly}
        incidentInvolvedPsapStates={incidentInvolvedPsapStates}
      />
    </DataPanel>
  );
}
